import { Helmet } from 'react-helmet'
import { useLocation, Location } from 'react-router-dom'
import { useAppThemeMeta } from 'shared/hooks/useAppTheme'
import { AppTheme } from 'shared/config/themes'

const EXCLUDED_PATHS = ['/links/fs', '/invite'] as const

export const MetaTags = () => {
  const location: Location = useLocation()
  const meta: AppTheme['meta'] = useAppThemeMeta()
  const shouldExclude = EXCLUDED_PATHS.some(path => location.pathname.startsWith(path))

  if (shouldExclude) return null
  
  const { title, ogDescription } = meta

  return (
    <Helmet>
      <title>
        {title}
      </title>

      <meta name="description"
        content={ogDescription}
      />

      <meta property="og:site_name"
        content={title}
      />

      <meta property="og:title"
        content={meta.ogTitle}
      />

      <meta property="og:description"
        content={ogDescription}
      />

      <meta property="og:type"
        content="website"
      />

      <meta property="og:url"
        content={meta.ogUrl}
      />

      <meta property="og:image"
        content={meta.ogImage}
      />

      <meta property="og:image:type"
        content="image/png"
      />

      <meta property="og:image:width"
        content="1200"
      />

      <meta property="og:image:height"
        content="630"
      />
    </Helmet>
  )
}
